/**
 * TanStack Query hooks for `on-the-go-campaign-monitoring-in-mobile-app`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	onTheGoCampaignMonitoringInMobileAppQueryKeys,
	type CreateOnTheGoCampaignMonitoringInMobileAppBody,
	type ListOnTheGoCampaignMonitoringInMobileAppResponse,
	type OnTheGoCampaignMonitoringInMobileAppRow,
} from "./api";

export function useOnTheGoCampaignMonitoringInMobileAppList(): UseQueryResult<ListOnTheGoCampaignMonitoringInMobileAppResponse, Error> {
	return useQuery({
		queryKey: onTheGoCampaignMonitoringInMobileAppQueryKeys.list(),
		queryFn: list,
	});
}

export function useOnTheGoCampaignMonitoringInMobileAppCreate(): UseMutationResult<OnTheGoCampaignMonitoringInMobileAppRow, Error, CreateOnTheGoCampaignMonitoringInMobileAppBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: onTheGoCampaignMonitoringInMobileAppQueryKeys.all });
		},
	});
}

export function useOnTheGoCampaignMonitoringInMobileAppDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: onTheGoCampaignMonitoringInMobileAppQueryKeys.all });
		},
	});
}
